import React, {Component} from 'react';
import { connect } from "react-redux";

import {getUSDfromBTC, updateRates} from "../Helpers/conversion";


class GiftAmount extends Component {
  componentDidMount() {
    if(!this.props.ratesUpdated) {
      updateRates(this.props.dispatch);
    }
  }
  render() {
    const usdAmount = getUSDfromBTC(this.props.giftAmount, this.props.rates);

    return <span>
      BTC { this.props.giftAmount } (USD ${usdAmount})
    </span>
  }
}

const mapStateToProps = (state) => ({
  giftAmount: state.gift.giftAmount,
  rates: state.conversionRates.rates,
  ratesUpdated: state.conversionRates.lastUpdated,
});

export default connect(mapStateToProps)(GiftAmount);



// WEBPACK FOOTER //
// ./src/Components/GiftAmount.js